import client from '../client';

const appointmentApi = {
  /** status: 'upcoming' | 'past' | 'cancelled' */
  list: (status) => client.get('/appointments', { status }),
  summary: () => client.get('/appointments/summary'),
  get: (id) => client.get(`/appointments/${id}`),
  create: ({ doctorId, date, time, reason }) => client.post('/appointments', { doctorId, date, time, reason }),
  cancel: (id, reason) => client.post(`/appointments/${id}/cancel`, { reason }),
  reschedule: (id, { date, time, reason }) => client.post(`/appointments/${id}/reschedule`, { date, time, reason }),
};

export default appointmentApi;
